import matchPath, { MatchOptions } from './matchPath';

// this is a fork from react-router-config

function computeRootMatch(pathname: string) {
  return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
}

export interface Route extends MatchOptions {
  key?: string;
  routes?: Route[];
}

function matchRouteToPath(
  route: Route,
  pathname: string,
  allowRoot: boolean,
  branch: {
    match: ReturnType<typeof matchPath>;
    route: Route;
  }[]
) {
  if (route.path) {
    return matchPath(pathname, route);
  }

  if (branch.length) {
    return branch[branch.length - 1].match; // use parent match
  }

  if (allowRoot) {
    return computeRootMatch(pathname); // use default "root" match
  }

  return null;
}

function matchRoutesRecursive(
  routes: Route[],
  pathname: string,
  allowRoot: boolean,
  branch: {
    match: ReturnType<typeof matchPath>;
    route: Route;
  }[]
) {
  routes.some(route => {
    const match = matchRouteToPath(route, pathname, allowRoot, branch);

    if (match) {
      branch.push({ route, match });

      if (route.routes) {
        matchRoutesRecursive(route.routes, pathname, allowRoot, branch);
      }
    }

    return !!match;
  });

  return branch;
}

export default function matchRoutes(routes: Route | Route[], pathname: string, allowRoot = true) {
  return matchRoutesRecursive(([] as Route[]).concat(routes), pathname, allowRoot, []);
}
